import { SVGProps } from "react";

export function MoneyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1287_61999)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 21.9854C20.985 21.9854 24 20.4854 24 18.2354V3.98535C24 2.48535 21 0.985352 17.25 0.985352C13.5 0.985352 10.5 2.48535 10.5 3.98535V9.23535C12.255 9.97035 13.755 11.2004 14.82 12.7604C15.555 12.9044 16.365 12.9839 17.25 12.9839C19.215 12.9839 20.85 12.5924 22.02 11.9549C22.1861 11.8636 22.3478 11.7644 22.5045 11.6579V13.7279C22.5045 14.0804 22.224 14.6279 21.3015 15.1319C20.4075 15.6194 19.0365 15.9779 17.2515 15.9779C16.8945 15.9779 16.5545 15.9644 16.2315 15.9374C16.3515 16.4324 16.4315 16.9374 16.4715 17.4524C16.7245 17.4664 16.9845 17.4734 17.2515 17.4734C19.2165 17.4734 20.8515 17.0819 22.0215 16.4444C22.1876 16.3531 22.3493 16.2539 22.506 16.1474V18.2174C22.506 18.5714 22.2825 19.0964 21.3195 19.6154C20.3715 20.1254 18.9495 20.4674 17.2545 20.4674C16.9095 20.4674 16.5755 20.4534 16.2525 20.4254C16.1372 20.9239 15.9822 21.4125 15.789 21.8864C16.261 21.9394 16.749 21.9659 17.253 21.9659L17.25 21.9854ZM21.3 10.6454C22.2225 10.1414 22.503 9.59385 22.503 9.24135V7.17135C22.348 7.27735 22.1865 7.37635 22.0185 7.46835C20.8515 8.10585 19.2135 8.49735 17.2485 8.49735C15.2835 8.49735 13.6485 8.10585 12.4785 7.46835C12.3124 7.37706 12.1507 7.27795 11.994 7.17135V9.24135C11.994 9.59385 12.2745 10.1414 13.197 10.6439C14.091 11.1314 15.462 11.4899 17.247 11.4899C19.032 11.4899 20.397 11.1314 21.297 10.6439L21.3 10.6454ZM12 4.73535C12 4.30335 12.1875 3.88785 12.537 3.63435C12.7275 3.49635 12.9345 3.35835 13.098 3.28335C13.5075 3.09435 15.558 2.48385 17.253 2.48385C18.948 2.48385 20.418 2.82435 21.408 3.28335C21.594 3.36885 21.7995 3.50235 21.981 3.63435C22.3275 3.88485 22.506 4.29735 22.506 4.72485V4.73385C22.506 5.08635 22.2255 5.63385 21.303 6.13785C20.409 6.62535 19.038 6.98385 17.253 6.98385C15.468 6.98385 14.103 6.62385 13.203 6.13785C12.2805 5.63535 12 5.08635 12 4.73535Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 18.2354C13.5 21.9704 10.485 24.9854 6.75 24.9854C3.015 24.9854 0 21.9704 0 18.2354C0 14.5004 3.015 11.4854 6.75 11.4854C10.485 11.4854 13.5 14.5004 13.5 18.2354ZM12 18.2354C12 21.1304 9.645 23.4854 6.75 23.4854C3.855 23.4854 1.5 21.1304 1.5 18.2354C1.5 15.3404 3.855 12.9854 6.75 12.9854C9.645 12.9854 12 15.3404 12 18.2354Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1287_61999">
          <rect
            width="24"
            height="25"
            fill="white"
            transform="translate(0 0.985352)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
